import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const viewTemplates = (setData) => {
  axiosInstance
    .get("/template/get", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.status === 200) {
        setData(res.data.data);
      }
    })
    .catch((err) => {
      if (err) {
        toast.error("Something went wrong");
      }
    });
};

export const addTemplate = (FormData, setOpen, setFormData, setData) => {
  axiosInstance
    .post("/template/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.status === 200) {
        toast.success("Template added successfully");
        setOpen(false);
        setFormData({
          templateName: "",
          description: "",
          type: "SMS",
          templateFor: "",
          template: "",
          status: 1,
          createdAt: new Date().toISOString(),
        });
        viewTemplates(setData);
      }
    })
    .catch((err) => {
      if (err) {
        toast.error("Something went wrong");
      }
    });
};
export const toggleDefault = (setData, body) => {
  axiosInstance
    .put("/template/toggle", body, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data?.success) {
        toast.success(`${body.templateName} is now default`);
        return viewTemplates(setData);
      } else {
        return toast.error(res.data?.message || "Something went wrong");
      }
    })
    .catch(() => {
      toast.error("Unexpected error");
    });
};

export const updateTemplate = (setData, FormData, setEditOpen) => {
  axiosInstance
    .put("/template/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res?.data?.status) {
        toast.success("Template updated successfully");
        setEditOpen(false);
        return viewTemplates(setData);
      } else {
        return toast.error(res?.data?.message || "Something went wrong");
      }
    })
    .catch(() => {
      toast.error("Unexpected error");
    });
};

export const deleteTemplate = (setData, body, setEditOpen) => {
  axiosInstance
    .delete(
      "/template/delete",
      { data: body },
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res?.data?.status === 1) {
        toast.success(res.data.message);
        setEditOpen(false);
        viewTemplates(setData); // <-- refresh list
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    })
    .catch(() => toast.error("Unexpected error"));
};
